import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { NavItem, NavItemType } from '../../../../Common/Layout/components/Navbar/navbar.component';
import { ResearchRequestDialogComponent } from '../../../../Common/Dialogs/components/ResearchRequestDialog/research-request-dialog.component';

export const kantarSupportNav: NavItem[] =
    [
        {
            label: 'Core.navigation.support.supportAndTraining',
            icon: 'fa-duotone fa-regular fa-headset',
            id: 'primaryNavSupport',
            collapsed: false,
            items: [
                {
                    label: 'Core.navigation.support.contactSupport',
                    url: 'https://www.kantarmedia.com/global/contact-us',
                    id: 'primaryNavContactUs'
                },
                {
                    label: 'Core.navigation.support.supportLibrary',
                    url: 'https://www.agilitypr.com/support/',
                    id: 'primaryNavSupportLibrary'
                },
                {
                    label: 'Core.navigation.support.submitRequest',
                    type: NavItemType.dialog,
                    permissions: [
                        userPermissionsEnum.targeting,
                        userPermissionsEnum.advancedTargeting
                    ],
                    dialogReference: ResearchRequestDialogComponent,
                    id: 'primaryNavSubmitResearchRequest',
                },
                {
                    label: 'Core.navigation.support.training',
                    url: 'https://www.kantar.com/contact/hq-general-contact',
                    id: 'primaryNavTraining'
                }
            ]
        }
    ];
